module.exports = __webpack_public_path__ + "img/4.d34b4b18.webp";